document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('menu-open', open);
    });
  }

  const revealItems = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.animate(
            [{ opacity: 0, transform: 'translateY(28px)' }, { opacity: 1, transform: 'none' }],
            { duration: 700, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'both' }
          );
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealItems.forEach((item) => observer.observe(item));
  }

  document.querySelectorAll('[data-carousel]').forEach((carousel) => {
    const viewport = carousel.querySelector('[data-carousel-viewport]');
    const slides = carousel.querySelectorAll('[data-carousel-slide]');
    const previous = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    if (!viewport || !slides.length) return;

    const move = (direction) => {
      const distance = slides[0].getBoundingClientRect().width + 16;
      viewport.scrollBy({ left: direction * distance, behavior: 'smooth' });
    };
    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const select = section.querySelector('[data-variant-select]');
    const price = section.querySelector('[data-product-price]');
    const addButton = section.querySelector('[data-add-button]');
    const addLabel = section.querySelector('[data-add-label]');
    const quantity = section.querySelector('[data-quantity]');

    select?.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const available = option.dataset.available === 'true';
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (addButton) addButton.disabled = !available;
      if (addLabel) addLabel.textContent = available ? 'Ajouter au panier' : 'Épuisé';
    });
    section.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      if (quantity) quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
    });
    section.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      if (quantity) quantity.value = Number(quantity.value || 1) + 1;
    });

    const gallery = section.querySelector('[data-product-gallery]');
    const images = gallery?.querySelectorAll('[data-product-image]') || [];
    const index = gallery?.querySelector('[data-product-index]');
    const scrollImage = (direction) => {
      if (!gallery || !images.length) return;
      gallery.scrollBy({ left: direction * gallery.clientWidth, behavior: 'smooth' });
    };
    gallery?.querySelector('[data-product-prev]')?.addEventListener('click', () => scrollImage(-1));
    gallery?.querySelector('[data-product-next]')?.addEventListener('click', () => scrollImage(1));
    gallery?.addEventListener('scroll', () => {
      if (index && gallery.clientWidth) index.textContent = String(Math.round(gallery.scrollLeft / gallery.clientWidth) + 1);
    }, { passive: true });

    const modal = section.querySelector('[data-size-guide-modal]');
    section.querySelector('[data-size-guide-open]')?.addEventListener('click', () => modal?.showModal());
    section.querySelector('[data-size-guide-close]')?.addEventListener('click', () => modal?.close());
    modal?.addEventListener('click', (event) => {
      if (event.target === modal) modal.close();
    });

    const zoomModal = section.querySelector('[data-product-zoom-modal]');
    const zoomImage = zoomModal?.querySelector('[data-product-zoom-image]');
    section.querySelectorAll('[data-product-zoom]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        if (!zoomModal || !zoomImage) return;
        zoomImage.src = trigger.dataset.zoomSrc || '';
        zoomModal.showModal();
      });
    });
    section.querySelector('[data-product-zoom-close]')?.addEventListener('click', () => zoomModal?.close());
    zoomModal?.addEventListener('click', (event) => {
      if (event.target === zoomModal) zoomModal.close();
    });
  });

  document.querySelectorAll('[data-collection-section]').forEach((section) => {
    const drawer = section.querySelector('[data-filter-drawer]');
    section.querySelector('[data-filter-open]')?.addEventListener('click', () => drawer?.showModal());
    section.querySelector('[data-filter-close]')?.addEventListener('click', () => drawer?.close());
    drawer?.addEventListener('click', (event) => {
      if (event.target === drawer) drawer.close();
    });

    const sortForm = section.querySelector('[data-sort-form]');
    const sortSelect = section.querySelector('[data-sort-select]');
    const sortMenu = section.querySelector('[data-sort-menu]');
    const sortLabel = section.querySelector('[data-sort-label]');
    section.querySelectorAll('[data-sort-value]').forEach((button) => {
      button.addEventListener('click', () => {
        if (sortSelect) sortSelect.value = button.dataset.sortValue;
        if (sortLabel) sortLabel.textContent = button.textContent;
        sortMenu?.removeAttribute('open');
        sortForm?.submit();
      });
    });
  });

  document.querySelectorAll('[data-cart-section]').forEach((section) => {
    section.querySelectorAll('.cart-line').forEach((line) => {
      const quantity = line.querySelector('[data-cart-quantity]');
      line.querySelector('[data-cart-minus]')?.addEventListener('click', () => {
        if (quantity) quantity.value = Math.max(0, Number(quantity.value || 1) - 1);
      });
      line.querySelector('[data-cart-plus]')?.addEventListener('click', () => {
        if (quantity) quantity.value = Number(quantity.value || 1) + 1;
      });
    });
  });

  document.querySelectorAll('[data-contact-menu]').forEach((menu) => {
    const form = menu.closest('form');
    const select = form?.querySelector('[data-contact-select]');
    const label = menu.querySelector('[data-contact-label]');
    menu.querySelectorAll('[data-contact-value]').forEach((button) => {
      button.addEventListener('click', () => {
        if (select) select.value = button.dataset.contactValue;
        if (label) label.textContent = button.textContent;
        menu.querySelectorAll('[data-contact-value]').forEach((item) => item.classList.toggle('is-active', item === button));
        menu.removeAttribute('open');
      });
    });
  });
});
